module.exports = (__webpack_require__(0))(16);


//////////////////
// WEBPACK FOOTER
// delegated ./src/models/UserModel.js from dll-reference girder_lib
// module id = 23
// module chunks = 0